export const convertCharacterToCapital = (startIndex: number, slicingIndex: number, inputString?: string | undefined): string => {
    return `${inputString?.charAt(startIndex)?.toUpperCase()}${inputString?.slice(slicingIndex)}`;
}